var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as Sentry from "@sentry/react";
import axios from 'axios';
import { z } from 'zod';
import packageJson from '../../package.json';
var sentryResponseSchema = z.object({
    environment: z.string(),
    sentry: z.object({
        dsn: z.string().url(),
        traces_sample_rate: z.coerce.number().nullable(),
        profiles_sample_rate: z.coerce.number().nullable(),
    })
});
axios.get('/api/sentry').then(function (response) {
    var parsed = sentryResponseSchema.safeParse(response.data);
    if (!parsed.success) {
        console.error("Failed to parse Sentry response. See attached errors. ", {
            response: response.data,
            status: response.statusText,
            errors: parsed.error
        });
        return;
    }
    Sentry.init({
        dsn: parsed.data.sentry.dsn,
        release: "batteryspray@".concat(packageJson.version || '1.0.0'),
        integrations: __spreadArray([], (!['production', 'local'].includes(parsed.data.environment)
            ? [Sentry.feedbackIntegration({ colorScheme: 'system' })]
            : []), true),
        replaysSessionSampleRate: parsed.data.environment === 'production' ? 0.1 : 0.75,
        replaysOnErrorSampleRate: 1.0
    });
    console.log("\u2705 Sentry initialized successfully (env: ".concat(parsed.data.environment, ")"));
});
